import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function StepPolicies({ data, update, readOnly = false }) {
  const { alcohol, enviromental, safety, deductions } = data;

  return (
    <Box
      component="section"
      className="nsp_step nsp_step_policies"
      sx={{
        "& h4": { fontSize: "1.3rem" },
        "& p, & ul": { fontSize: "1.1rem" },
      }}
    >
      <Typography variant="h6" sx={{ mt: 1 }}>
        Alcohol Policy
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Typography sx={{ mb: 1 }}>
        Management Policy Statement on employee and contractor alcohol and drug
        abuse.
      </Typography>
      <Box component="ul" sx={{ mb: 1 }}>
        <li>
          The company is committed to a safe, healthy and productive workplace
          for all employees and contractors.
        </li>
        <li>
          The company recognises that abuse of alcohol, drugs or other
          substance by an employee or contractor will impair that person&apos;s
          ability to work properly and safely and could have serious
          consequences for the safety and efficiency of other employees or
          contractors. Such behaviour could also damage the company&apos;s
          reputation with the public.
        </li>
        <li>
          The use, possession, distribution or sale of any illegal or
          unprescribed drugs or the misuse of legitimately prescribed drugs on
          company premises is strictly prohibited and is grounds for instant
          dismissal.
        </li>
        <li>
          Possession, consumption, distribution or sale of alcoholic beverages,
          save in the normal course of company trading, is strictly prohibited
          and is grounds for instant dismissal.
        </li>
        <li>
          Being unfit for work because of misuse of drugs or alcohol is
          strictly prohibited and is grounds for instant dismissal.
        </li>
        <li>
          Whilst the policy above refers specifically to alcohol and drugs, it
          applies to all forms of substance abuse.
        </li>
        <li>
          Contractors working on company premises are expected to enforce similar
          policies regarding alcohol and drug abuse.
        </li>
      </Box>
      <Typography sx={{ mb: 2 }}>
        Contractors working on company premises are expected to enforce similar
        policies regarding alcohol and drug abuse.
      </Typography>
      {!readOnly && (
        <Paper variant="outlined" sx={{ p: 1.5, mb: 3 }}>
          <FormControlLabel
            sx={{ alignItems: "flex-start", m: 0, width: "100%" }}
            control={
              <Checkbox
                id="alcohol-agree"
                checked={alcohol}
                onChange={() => update("alcohol", !alcohol)}
              />
            }
            label="I have read and agree to the Alcohol Policy"
          />
        </Paper>
      )}

      <Typography variant="h6">Environmental Policy</Typography>
      <Divider sx={{ mb: 2 }} />
      <Typography sx={{ mb: 1 }}>Management Environmental Policy Statement</Typography>
      <Box component="ul" sx={{ mb: 1 }}>
        <li>
          The company will ensure that all activities meet legal and EC
          Directives/requirements and conditions of any applicable Planning
          Consents.
        </li>
        <li>
          The company will maintain a safe environment for all employees,
          customers and contractors.
        </li>
        <li>
          The company is committed to be a good neighbour and to minimise the
          impact of any company activities on the neighbourhood.
        </li>
        <li>
          Wherever reasonably practicable, the company will use environmentally
          friendly materials, substances and equipment and strive to improve the
          environmental awareness of all staff.
        </li>
        <li>
          In the event of any spills of product, leaks or other incident likely
          to cause any contamination, the company will take all steps to contain
          and dispose of waste products in an appropriate manner to facilities
          equipped and licensed to deal with them. All statutory bodies will be
          notified.
        </li>
      </Box>
      <Typography sx={{ mb: 2 }}>
        All employees/contractors working on company premises are expected to
        confirm to the above policy.
      </Typography>
      {!readOnly && (
        <Paper variant="outlined" sx={{ p: 1.5, mb: 3 }}>
          <FormControlLabel
            sx={{ alignItems: "flex-start", m: 0, width: "100%" }}
            control={
              <Checkbox
                id="environment-agree"
                checked={enviromental}
                onChange={() => update("enviromental", !enviromental)}
              />
            }
            label="I have read and agree to the Environmental Policy"
          />
        </Paper>
      )}

      <Typography variant="h6">Safety Policy</Typography>
      <Divider sx={{ mb: 2 }} />
      <Typography sx={{ mb: 1 }}>
        Management Safety Policy Statement. - Health &amp; Safety at Work etc.
        Act 1974.
      </Typography>
      <Box component="ul" sx={{ mb: 1 }}>
        <li>
          In addition to complying strictly with health and safety measures as
          required by legislation, it will be the Company&apos;s policy to
          promote, and give high priority to, the continuing establishment of a
          healthy and safe working environment.
        </li>
        <li>
          The Company recognises that an effective policy depends on a dedicated
          attitude by all its employees, whether directly employed or
          sub-contracted.
        </li>
        <li>
          The Company&apos;s objective is to ensure that for the protection and
          health, both of Its employees and the general public, working
          conditions and practices are established and continuously reviewed to
          achieve a safe, healthy and injury-free operation by means of:
        </li>
        <li>A safe and healthy working environment.</li>
        <li>Appropriate training and employee instruction.</li>
        <li>
          Identification of potential hazards to health and safety in the
          workplace and the implementation of plans to eliminate or control
          such hazards.
        </li>
        <li>Provision of appropriate and adequate protective clothing.</li>
        <li>Provision of specialist advice where appropriate.</li>
        <li>
          Awareness by employees that they themselves have a clear duty to take
          every reasonable precaution to avoid injury to themselves, their
          colleagues and members of the public.
        </li>
        <li>
          The Company will expect that any contractors carrying out work on
          behalf of the Company will have in place adequate health and safety
          procedures and standards to safeguard their own employees in addition
          to the Company&apos;s employees and the general public. The Company
          will take reasonable steps to ensure that such contractors abide by
          their procedures.
        </li>
      </Box>
      <Typography sx={{ mb: 2 }}>
        Responsibility for implementing and monitoring this policy lies with
        the management.
      </Typography>
      {!readOnly && (
        <Paper variant="outlined" sx={{ p: 1.5, mb: 3 }}>
          <FormControlLabel
            sx={{ alignItems: "flex-start", m: 0, width: "100%" }}
            control={
              <Checkbox
                id="safety-agree"
                checked={safety}
                onChange={() => update("safety", !safety)}
              />
            }
            label="I have read and agree to the Safety Policy"
          />
        </Paper>
      )}

      <Typography variant="h6">Deductions from Pay Agreement</Typography>
      <Divider sx={{ mb: 2 }} />
      <Box component="ul" sx={{ mb: 1 }}>
        <li>
          If you are overpaid for any reason, the total amount of the
          overpayment will normally be deducted from your next payment but if
          this would cause hardship, arrangements may be made for the
          overpayment to be recovered over a longer period.
        </li>
        <li>
          If you are hourly paid and you &quot;clock in&quot; late you will lose
          pay. If you &quot;clock in&quot; 5 minutes late you will lose 5
          minutes pay and so on.
        </li>
        <li>
          If you arrive for work more than one hour late without having
          previously notified us, other arrangements may have been made to cover
          your duties and you may be sent off the premises for the remainder of
          the shift without pay.
        </li>
        <li>
          Lateness or absence may result in disciplinary action and/or loss of
          appropriate payment.
        </li>
        <li>
          If there is a temporary shortage of work for any reason, we will try
          to maintain your continuity of employment even if this necessitates
          placing you on short time working, or alternatively, lay off. If you
          are placed on short time working, your pay will be reduced according
          to time actually worked. If you are placed on lay off, you will
          receive no pay other than statutory guarantee pay.
        </li>
        <li>
          If you are an allocated key holder, you must ensure that all
          procedures and guidelines are followed when securing the building
          prior to leaving. The keys and any security measure such as alarm
          codes must be kept safe at all times. You must not give the keys or
          alarm code to any third party unless authorisation is obtained from a
          Manager. Any loss or damage caused as a result of your failure to
          follow procedures or your negligence in ensuring the safekeeping of
          the keys and alarm code will result in disciplinary action which could
          lead to your summary dismissal. We also reserve the right to deduct
          the cost of any loss, repair or replacement from any monies owing to
          you.
        </li>
        <li>
          Any cash shortages, this includes discrepancies in Paypoint and
          Lotto, at the end of the shift will be the responsibility of the
          shift on duty and must be made good by that shift or stock
          deficiencies that you are found to be responsible for. Any such
          shortages will be deducted from wages.
        </li>
        <li>Any amounts owing to your personal staff account.</li>
        <li>
          Any fuel that you have not called down on your till and/or failure to
          ask a customer if they have any fuel to pay for or any fuel card sale
          that has been incorrectly cashed. Any such shortages will be deducted
          from wages.
        </li>
        <li>
          Any damage to vehicles, stock or property (including non-statutory
          safety equipment) that is the result of your carelessness, negligence
          or deliberate vandalism will render you liable to pay the full or part
          of the cost of repair or replacement.
          <ul>
            <li>
              Any loss to us that is the result of your failure to observe
              rules, procedures or instruction, or is as a result of your
              negligent behaviour or your unsatisfactory standards of work will
              render you liable to reimburse to us the full or part of the cost
              of the loss.
            </li>
            <li>
              In the event of an at fault accident whilst driving one of our
              vehicles you may be required to pay the cost of the insurance
              excess up to a maximum of £250.00.
            </li>
            <li>
              In the event of failure to pay, such costs will be deducted from
              your pay.
            </li>
          </ul>
        </li>
        <li>
          On termination of your employment you must return any Company vehicle
          in your possession to our premises. Failure to return the vehicle
          will result in the cost of its recovery being deducted from any
          monies outstanding to you.
        </li>
        <li>
          Any fines imposed by relevant authorities including (but not limited
          to) speeding and parking will be payable by the employee. The Company
          take no responsibility for the payment of fines incurred by the
          employee during their employment. In the event that the Company
          receive the summons on the employee&apos;s behalf or owing to a fine
          incurred by the employee, we may pay the fine and deduct the cost from
          the employee&apos;s wage.
        </li>
        <li>
          Failure to adequately clean the vehicle may mean you are subject to
          the cost of the valet being deducted from your pay.
        </li>
        <li>
          If you arrive for work and, in our opinion, you are not fit to work,
          we reserve the right to exercise our duty of care if we believe that
          you may not be able to undertake your duties in a safe manner or may
          pose a safety risk to others, and send you away for the remainder of
          the day with or without pay and, dependent on the circumstances, you
          may be liable to disciplinary action.
        </li>
        <li>Any goods purchased by you from the Employer.</li>
        <li>
          If you terminate your employment without giving or working the
          required period of notice, as indicated in your individual statement
          of main terms of employment, you will have an amount equal to any
          additional cost of covering your duties during the notice period not
          worked deducted from any termination pay due to you. You will also
          forfeit any contractual accrued holiday pay due to you over and above
          your statutory holiday pay, if you fail to give or work the required
          period of notice.
        </li>
        <li>
          On the termination of your employment you must return all our
          property which is in your possession or for which you have
          responsibility. Failure to return such items will result in the cost
          of the items being deducted from any monies outstanding to you.
        </li>
        <li>
          On the termination of your employment you must return all items of
          your uniform to us. Failure to return such items will result in the
          cost of the items being deducted from any monies outstanding to you.
        </li>
      </Box>
      {!readOnly && (
        <Paper variant="outlined" sx={{ p: 1.5 }}>
          <FormControlLabel
            sx={{ alignItems: "flex-start", m: 0, width: "100%" }}
            control={
              <Checkbox
                id="deduction-agree"
                checked={deductions}
                onChange={() => update("deductions", !deductions)}
              />
            }
            label="I have read and agree to the Deductions from Pay Agreement"
          />
        </Paper>
      )}
    </Box>
  );
}
